var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGracias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 696.589,
    height: 648.503,
    viewBox: "0 0 696.589 648.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2728",
    "data-name": "Rect\\xE1ngulo 2728",
    width: 345.159,
    height: 193.198
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2729",
    "data-name": "Rect\\xE1ngulo 2729",
    width: 363.801,
    height: 203.366
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2730",
    "data-name": "Rect\\xE1ngulo 2730",
    width: 423.68,
    height: 236.697
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2731",
    "data-name": "Rect\\xE1ngulo 2731",
    width: 155.914,
    height: 121.455
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.465,
    y1: -0.545,
    x2: 0.4,
    y2: 1.737,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#d6d7d8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2749",
    "data-name": "Rect\\xE1ngulo 2749",
    width: 464.354,
    height: 255.338
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.599,
    y1: 5.968,
    x2: 4.099,
    y2: 5.968,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#235677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78a9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 5.217,
    y1: 16.982,
    x2: 7.717,
    y2: 16.982,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deeafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1c3fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4.753,
    y1: 17.434,
    x2: 7.253,
    y2: 17.434,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2.029,
    y1: 33.955,
    x2: 4.529,
    y2: 33.955,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 81.498,
    y1: 154.09,
    x2: 83.998,
    y2: 154.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2750",
    "data-name": "Rect\\xE1ngulo 2750",
    width: 131.058,
    height: 102.249
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2751",
    "data-name": "Rect\\xE1ngulo 2751",
    width: 79.652,
    height: 62.139
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2752",
    "data-name": "Rect\\xE1ngulo 2752",
    width: 107.332,
    height: 83.606
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-mail_marketing_campaign",
    "data-name": "E-mail marketing campaign",
    transform: "translate(-189 -86.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9293",
    "data-name": "Grupo 9293",
    transform: "translate(521.109 256.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9292",
    "data-name": "Grupo 9292",
    transform: "matrix(-0.994, 0.111, -0.111, -0.994, 364.48, 192.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9291",
    "data-name": "Grupo 9291",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "texture-2_6_-i0",
    d: "M64.649,43.087a.868.868,0,1,1-.483-1.134h0a.87.87,0,0,1,.483,1.134ZM1.658,106.153a.894.894,0,0,1-.461,1.174h0a.807.807,0,0,1-1.078-.39.4.4,0,0,1-.04-.108.863.863,0,0,1,.413-1.14.894.894,0,0,1,1.166.464Zm29.86-34a.974.974,0,0,1-.008,1.283.9.9,0,0,1-1.276-.008.909.909,0,0,1,.008-1.283A.967.967,0,0,1,31.519,72.149Zm104.5,50a1.7,1.7,0,0,1,.144,2.371,1.6,1.6,0,0,1-2.252.249.616.616,0,0,1-.066-.058,1.7,1.7,0,0,1-.144-2.371,1.639,1.639,0,0,1,2.318-.191ZM105.679,95.629A1.681,1.681,0,0,1,105.788,98a1.668,1.668,0,0,1-2.514-2.191h0A1.774,1.774,0,0,1,105.679,95.629ZM75.266,69.091a1.65,1.65,0,0,1,.179,2.323l-.037.042a1.6,1.6,0,0,1-2.252.249.613.613,0,0,1-.066-.058,1.8,1.8,0,0,1-.179-2.42A1.685,1.685,0,0,1,75.266,69.091Zm86.981-29.311a1.651,1.651,0,1,1-1.015-2.151,1.719,1.719,0,0,1,1.015,2.151ZM124.084,26.955a1.651,1.651,0,1,1-1.015-2.151,1.719,1.719,0,0,1,1.015,2.151ZM62.218,156.289a1.691,1.691,0,0,1-.779,2.241,1.62,1.62,0,0,1-2.186-.717l-.008-.015a1.613,1.613,0,0,1,.58-2.194l.115-.064A1.771,1.771,0,0,1,62.218,156.289Zm-18-36.224a1.785,1.785,0,0,1-.738,2.289A1.679,1.679,0,0,1,42,119.342l.027-.015a1.616,1.616,0,0,1,2.181.713A.125.125,0,0,0,44.218,120.066ZM26.253,83.9a1.6,1.6,0,0,1-.656,2.166.353.353,0,0,1-.07.033,1.647,1.647,0,0,1-2.239-.668c-.014-.027-.027-.047-.04-.073a1.685,1.685,0,0,1,.761-2.246,1.666,1.666,0,0,1,2.233.765C26.247,83.886,26.251,83.893,26.253,83.9ZM173.75,1.815a1.48,1.48,0,1,1-2.886-.656A1.478,1.478,0,0,1,172.633.036h0A1.505,1.505,0,0,1,173.75,1.815ZM85.8,124.441a1.585,1.585,0,0,1-.5,2.109,1.429,1.429,0,0,1-1.98-.442l-.032-.058A1.483,1.483,0,0,1,83.713,124l.027-.015a1.548,1.548,0,0,1,2.056.459ZM66.758,93.89a1.486,1.486,0,0,1-.489,2.026,1.429,1.429,0,0,1-1.98-.442l-.032-.058a1.493,1.493,0,0,1,.428-2.059l.027-.015a1.523,1.523,0,0,1,2.045.548ZM47.7,63.206a1.493,1.493,0,0,1-.428,2.059l-.027.015a1.4,1.4,0,0,1-1.943-.374,1.41,1.41,0,0,1-.075-.123,1.493,1.493,0,0,1,.428-2.059l.027-.015a1.51,1.51,0,0,1,2.017.5Zm80.948-5.193a1.519,1.519,0,0,1,.3,2.095,1.46,1.46,0,0,1-2.044.354,1.571,1.571,0,0,1-.39-2.1,1.536,1.536,0,0,1,2.13-.346ZM99.372,37.063a1.44,1.44,0,0,1,.407,1.985.586.586,0,0,0-.047.074,1.46,1.46,0,0,1-2.044.354,1.571,1.571,0,0,1-.39-2.1,1.487,1.487,0,0,1,2.074-.31Zm-86.06,96.184A1.417,1.417,0,0,1,12.2,134.9a.649.649,0,0,1-.087.015,1.483,1.483,0,0,1-1.736-1.172.438.438,0,0,1-.008-.05,1.539,1.539,0,0,1,1.256-1.708,1.46,1.46,0,0,1,1.686,1.195.262.262,0,0,0,0,.066ZM7.377,97.6A1.535,1.535,0,0,1,6.16,99.349a1.511,1.511,0,0,1-.523-2.973,1.465,1.465,0,0,1,1.73,1.137.443.443,0,0,1,.01.083ZM201.226,28.409a1.8,1.8,0,0,1,.347,2.443,1.712,1.712,0,0,1-2.388.395,1.779,1.779,0,0,1-.347-2.443,1.714,1.714,0,0,1,2.389-.395ZM167.687,3.878a1.73,1.73,0,0,1,.392,2.4,1.709,1.709,0,0,1-2.389.395,1.73,1.73,0,0,1-.392-2.4,1.709,1.709,0,0,1,2.389-.395ZM53,121.118a1.811,1.811,0,0,1-1.468,2.016,1.741,1.741,0,0,1-.5-3.444A1.762,1.762,0,0,1,53,121.118Zm-6.445-41.2A1.766,1.766,0,0,1,45.132,81.9,1.726,1.726,0,0,1,44.58,78.5a1.751,1.751,0,0,1,1.97,1.426ZM128.6,71.34a1.846,1.846,0,0,1-.582,2.4,1.727,1.727,0,0,1-2.339-.625,1.7,1.7,0,0,1,.51-2.344l.032-.017a1.722,1.722,0,0,1,2.379.588ZM106.949,35.724a1.754,1.754,0,0,1-.577,2.4l0,0a1.666,1.666,0,0,1-2.3-.573h0a1.719,1.719,0,0,1,.553-2.355,1.685,1.685,0,0,1,2.326.529Zm48.84,27.219a1.719,1.719,0,0,1-.536,2.359,1.693,1.693,0,0,1-2.346-.538,1.7,1.7,0,1,1,2.881-1.821ZM132.8,28.421a1.734,1.734,0,0,1-2.863,1.954,1.839,1.839,0,0,1,.463-2.455,1.771,1.771,0,0,1,2.4.5ZM70.429,76.151a1.761,1.761,0,0,1-1.385,2.032,1.73,1.73,0,0,1-.757-3.372.236.236,0,0,1,.074-.013,1.707,1.707,0,0,1,2.051,1.3.144.144,0,0,1,.017.054Z",
    transform: "translate(143.257 34.489)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19384",
    "data-name": "Trazado 19384",
    d: "M0,12.554,12.479,20.59,20.467,8.036,7.988,0Z",
    transform: "translate(312.515 165.533)",
    fill: "#235677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19385",
    "data-name": "Trazado 19385",
    d: "M4.518,18.744,18.631,14.2,14.113,0,0,4.545Z",
    transform: "translate(34.793 137.551)",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19386",
    "data-name": "Trazado 19386",
    d: "M0,16.79,16.689,27.537l10.683-16.79L10.683,0Z",
    transform: "translate(111.86 103.178)",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9288",
    "data-name": "Grupo 9288",
    transform: "translate(0 58.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19387",
    "data-name": "Trazado 19387",
    d: "M76.515,0a.6.6,0,0,0-.5.269C59.373,25.267,30.471,41.4.584,42.378A.6.6,0,0,0,0,43a.632.632,0,0,0,.623.587C30.894,42.6,60.165,26.262,77.018.945a.606.606,0,0,0-.5-.945Z",
    fill: "#428dfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9289",
    "data-name": "Grupo 9289",
    transform: "translate(8.723 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19388",
    "data-name": "Trazado 19388",
    d: "M66.167,0a.6.6,0,0,0-.345.109C47.192,13.207,21.093,14.984.88,4.534A.6.6,0,0,0,.067,4.8a.61.61,0,0,0,.261.818c20.6,10.654,47.2,8.839,66.186-4.507a.608.608,0,0,0,.149-.845A.6.6,0,0,0,66.167,0Z",
    transform: "translate(0 0)",
    fill: "#428dfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9290",
    "data-name": "Grupo 9290",
    transform: "translate(218.324 73.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19389",
    "data-name": "Trazado 19389",
    d: "M.6,0a.6.6,0,0,0-.4.148.611.611,0,0,0-.06.858,95.872,95.872,0,0,0,74.5,33.012c.332-.008.6-.045.587-.381s-.277-.347-.6-.347H74.61C46.8,33.29,19.293,21.609,1.059.455.94.314.772,0,.6,0Z",
    transform: "translate(0 0)",
    fill: "#428dfc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9299",
    "data-name": "Grupo 9299",
    transform: "translate(213.291 318.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9298",
    "data-name": "Grupo 9298",
    transform: "translate(363.801 203.366) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9297",
    "data-name": "Grupo 9297",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "texture-2_6_-i1",
    d: "M68.141,45.355a.914.914,0,1,1-.509-1.194h0a.915.915,0,0,1,.509,1.194ZM1.748,111.741a.941.941,0,0,1-.486,1.236h0a.851.851,0,0,1-1.137-.41.416.416,0,0,1-.042-.114.908.908,0,0,1,.436-1.2.943.943,0,0,1,1.229.488ZM33.221,75.947a1.024,1.024,0,0,1-.008,1.351.946.946,0,0,1-1.345-.008.956.956,0,0,1,.008-1.351A1.02,1.02,0,0,1,33.221,75.947Zm110.141,52.635a1.792,1.792,0,0,1,.151,2.5,1.687,1.687,0,0,1-2.373.262.651.651,0,0,1-.07-.061,1.792,1.792,0,0,1-.151-2.5,1.729,1.729,0,0,1,2.443-.2Zm-31.976-27.92a1.768,1.768,0,0,1,.115,2.5,1.757,1.757,0,0,1-2.65-2.306h0A1.871,1.871,0,0,1,111.386,100.662ZM79.331,72.728a1.735,1.735,0,0,1,.188,2.445l-.039.044a1.687,1.687,0,0,1-2.373.262.646.646,0,0,1-.07-.061,1.889,1.889,0,0,1-.188-2.548A1.778,1.778,0,0,1,79.331,72.728ZM171.01,41.874a1.74,1.74,0,1,1-1.07-2.265,1.809,1.809,0,0,1,1.07,2.265Zm-40.224-13.5a1.74,1.74,0,1,1-1.07-2.265,1.808,1.808,0,0,1,1.07,2.265ZM65.578,164.515a1.779,1.779,0,0,1-.821,2.359,1.708,1.708,0,0,1-2.3-.755l-.009-.015a1.7,1.7,0,0,1,.611-2.309l.121-.068A1.868,1.868,0,0,1,65.578,164.515Zm-18.972-38.13a1.878,1.878,0,0,1-.778,2.409,1.768,1.768,0,0,1-1.564-3.171l.028-.015a1.7,1.7,0,0,1,2.3.75A.134.134,0,0,0,46.606,126.385ZM27.671,88.313a1.686,1.686,0,0,1-.691,2.28.372.372,0,0,1-.073.034,1.738,1.738,0,0,1-2.36-.7c-.015-.028-.028-.05-.042-.077a1.76,1.76,0,1,1,3.156-1.559C27.664,88.3,27.669,88.308,27.671,88.313Zm155.463-86.4a1.56,1.56,0,1,1-3.042-.69A1.558,1.558,0,0,1,181.957.038h0A1.584,1.584,0,0,1,183.134,1.911Zm-92.7,129.08a1.667,1.667,0,0,1-.53,2.22,1.508,1.508,0,0,1-2.087-.465l-.033-.061a1.56,1.56,0,0,1,.455-2.162l.028-.015a1.633,1.633,0,0,1,2.168.483ZM70.364,98.831a1.564,1.564,0,0,1-.515,2.133,1.508,1.508,0,0,1-2.087-.465l-.033-.061a1.57,1.57,0,0,1,.451-2.168l.028-.015a1.606,1.606,0,0,1,2.156.577Zm-20.086-32.3a1.57,1.57,0,0,1-.451,2.168l-.028.015a1.472,1.472,0,0,1-2.047-.394,1.49,1.49,0,0,1-.079-.129,1.57,1.57,0,0,1,.451-2.168l.028-.015a1.592,1.592,0,0,1,2.126.523Zm85.32-5.467a1.6,1.6,0,0,1,.321,2.2,1.54,1.54,0,0,1-2.154.372,1.652,1.652,0,0,1-.411-2.213,1.62,1.62,0,0,1,2.245-.364ZM104.739,39.014a1.515,1.515,0,0,1,.429,2.089.62.62,0,0,0-.049.078,1.54,1.54,0,0,1-2.154.372,1.653,1.653,0,0,1-.411-2.213,1.568,1.568,0,0,1,2.186-.327ZM14.031,140.261A1.491,1.491,0,0,1,12.856,142a.685.685,0,0,1-.092.015,1.563,1.563,0,0,1-1.83-1.234.457.457,0,0,1-.009-.052,1.621,1.621,0,0,1,1.324-1.8,1.538,1.538,0,0,1,1.778,1.257.276.276,0,0,0,0,.069ZM7.775,102.733a1.616,1.616,0,0,1-1.283,1.846,1.59,1.59,0,0,1-.551-3.13,1.544,1.544,0,0,1,1.823,1.2.466.466,0,0,1,.01.087ZM212.094,29.9a1.892,1.892,0,0,1,.365,2.572,1.806,1.806,0,0,1-2.517.415,1.871,1.871,0,0,1-.365-2.572,1.808,1.808,0,0,1,2.517-.415ZM176.743,4.082a1.81,1.81,0,1,1-2.518.415,1.819,1.819,0,0,1,2.518-.415ZM55.858,127.492a1.907,1.907,0,0,1-1.547,2.123,1.833,1.833,0,0,1-.531-3.626,1.857,1.857,0,0,1,2.078,1.5ZM49.065,84.129a1.859,1.859,0,0,1-1.494,2.086,1.817,1.817,0,0,1-.582-3.588,1.846,1.846,0,0,1,2.077,1.5Zm86.482-9.034a1.941,1.941,0,0,1-.613,2.525,1.822,1.822,0,0,1-2.465-.658,1.788,1.788,0,0,1,.538-2.467l.033-.018a1.817,1.817,0,0,1,2.507.619ZM112.725,37.6a1.845,1.845,0,0,1-.608,2.522l-.005,0a1.757,1.757,0,0,1-2.421-.6h0a1.808,1.808,0,0,1,.583-2.479,1.777,1.777,0,0,1,2.451.557ZM164.2,66.256a1.808,1.808,0,0,1-.565,2.483,1.786,1.786,0,0,1-2.472-.566,1.8,1.8,0,1,1,3.037-1.916ZM139.973,29.917a1.826,1.826,0,0,1-3.018,2.057,1.934,1.934,0,0,1,.488-2.585,1.868,1.868,0,0,1,2.53.528ZM74.233,80.159a1.853,1.853,0,0,1-1.46,2.139,1.821,1.821,0,0,1-.8-3.549.249.249,0,0,1,.078-.014A1.8,1.8,0,0,1,74.216,80.1a.153.153,0,0,1,.017.057Z",
    transform: "translate(150.994 36.304)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19390",
    "data-name": "Trazado 19390",
    d: "M0,13.214l13.153,8.46L21.572,8.459,8.419,0Z",
    transform: "translate(329.394 174.245)",
    fill: "#235677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19391",
    "data-name": "Trazado 19391",
    d: "M4.762,19.73l14.875-4.785L14.875,0,0,4.785Z",
    transform: "translate(36.672 144.79)",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19392",
    "data-name": "Trazado 19392",
    d: "M0,17.674,17.59,28.987,28.85,11.313,11.26,0Z",
    transform: "translate(117.901 108.609)",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9294",
    "data-name": "Grupo 9294",
    transform: "translate(0 61.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19393",
    "data-name": "Trazado 19393",
    d: "M80.648,0a.638.638,0,0,0-.53.284C62.58,26.6,32.117,43.58.615,44.608a.637.637,0,0,0-.615.66.666.666,0,0,0,.657.617C32.563,44.846,63.414,27.644,81.177.995A.638.638,0,0,0,80.648,0Z",
    fill: "#428dfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9295",
    "data-name": "Grupo 9295",
    transform: "translate(9.194 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19394",
    "data-name": "Trazado 19394",
    d: "M69.741,0a.629.629,0,0,0-.364.115C49.741,13.9,22.232,15.772.927,4.772a.632.632,0,0,0-.857.276.642.642,0,0,0,.275.861c21.713,11.214,49.748,9.3,69.76-4.744a.639.639,0,0,0,.157-.89A.627.627,0,0,0,69.741,0Z",
    transform: "translate(0)",
    fill: "#428dfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9296",
    "data-name": "Grupo 9296",
    transform: "translate(230.115 77.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19395",
    "data-name": "Trazado 19395",
    d: "M.637,0A.634.634,0,0,0,.219.156a.643.643,0,0,0-.063.9,101.109,101.109,0,0,0,78.52,34.749c.35-.009.627-.047.618-.4s-.292-.365-.637-.365h-.018c-29.315,0-58.3-12.3-77.523-34.564C.99.331.814,0,.637,0Z",
    transform: "translate(0 0)",
    fill: "#428dfc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9305",
    "data-name": "Grupo 9305",
    transform: "translate(222.423 86.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9304",
    "data-name": "Grupo 9304",
    transform: "matrix(0.936, -0.353, 0.353, 0.936, 0, 149.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9303",
    "data-name": "Grupo 9303",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "texture-2_6_-i2",
    d: "M79.356,141.654a1.065,1.065,0,1,0-.592,1.39h0a1.065,1.065,0,0,0,.592-1.39ZM2.036,64.389a1.1,1.1,0,0,0-.566-1.438h0a.992.992,0,0,0-1.324.478.485.485,0,0,0-.049.132,1.056,1.056,0,0,0,.508,1.4,1.1,1.1,0,0,0,1.431-.568Zm36.653,41.66a1.191,1.191,0,0,0-.009-1.572,1.109,1.109,0,0,0-1.557,1.581A1.189,1.189,0,0,0,38.689,106.049Zm128.27-61.261a2.085,2.085,0,0,0,.176-2.9,1.965,1.965,0,0,0-2.764-.305.753.753,0,0,0-.081.071,2.085,2.085,0,0,0-.176,2.9,2.014,2.014,0,0,0,2.845.234Zm-37.239,32.5a2.057,2.057,0,0,0,.134-2.9,2.046,2.046,0,0,0-3.086,2.684h0A2.18,2.18,0,0,0,129.72,77.283ZM92.388,109.8a2.019,2.019,0,0,0,.219-2.845l-.046-.051a1.965,1.965,0,0,0-2.764-.305.754.754,0,0,0-.081.071,2.2,2.2,0,0,0-.219,2.965A2.071,2.071,0,0,0,92.388,109.8Zm106.769,35.91a2.026,2.026,0,1,0-1.246,2.636,2.1,2.1,0,0,0,1.246-2.636Zm-46.845,15.714a2.026,2.026,0,1,0-1.246,2.636,2.1,2.1,0,0,0,1.246-2.636ZM76.372,2.964A2.07,2.07,0,0,0,75.416.219a1.99,1.99,0,0,0-2.683.879l-.01.018A1.974,1.974,0,0,0,73.435,3.8l.141.079A2.176,2.176,0,0,0,76.372,2.964ZM54.277,47.344a2.185,2.185,0,0,0-.906-2.8,2.058,2.058,0,0,0-1.821,3.69l.033.018a1.986,1.986,0,0,0,2.678-.873A.154.154,0,0,1,54.277,47.344ZM32.225,91.655A1.962,1.962,0,0,0,31.42,89a.434.434,0,0,0-.086-.04,2.024,2.024,0,0,0-2.749.818c-.018.033-.033.058-.049.089a2.049,2.049,0,1,0,3.675,1.815C32.218,91.67,32.223,91.661,32.225,91.655ZM213.276,192.218a1.816,1.816,0,1,0-3.543.8,1.815,1.815,0,0,0,2.172,1.377h0A1.844,1.844,0,0,0,213.276,192.218ZM105.314,41.983A1.94,1.94,0,0,0,104.7,39.4a1.756,1.756,0,0,0-2.43.541l-.039.071a1.815,1.815,0,0,0,.53,2.516l.033.018a1.9,1.9,0,0,0,2.524-.562ZM81.945,79.413a1.819,1.819,0,0,0-.6-2.482,1.756,1.756,0,0,0-2.43.541l-.039.071a1.827,1.827,0,0,0,.525,2.523l.033.018a1.871,1.871,0,0,0,2.511-.671ZM58.553,117.006a1.827,1.827,0,0,0-.525-2.523l-.033-.018a1.722,1.722,0,0,0-2.476.608,1.827,1.827,0,0,0,.525,2.523l.033.018a1.855,1.855,0,0,0,2.476-.608Zm99.363,6.363a1.859,1.859,0,0,0,.374-2.566,1.794,1.794,0,0,0-2.509-.434,1.923,1.923,0,0,0-.479,2.576,1.887,1.887,0,0,0,2.614.424Zm-35.937,25.666a1.763,1.763,0,0,0,.5-2.431.731.731,0,0,1-.058-.091,1.794,1.794,0,0,0-2.509-.434,1.923,1.923,0,0,0-.479,2.576,1.827,1.827,0,0,0,2.546.38ZM16.341,31.194a1.736,1.736,0,0,0-1.368-2.028.8.8,0,0,0-.107-.018,1.82,1.82,0,0,0-2.131,1.436.537.537,0,0,0-.01.061,1.886,1.886,0,0,0,1.542,2.092,1.791,1.791,0,0,0,2.07-1.463.322.322,0,0,1,0-.081ZM9.055,74.873a1.881,1.881,0,0,0-1.494-2.148,1.851,1.851,0,0,0-.641,3.643,1.8,1.8,0,0,0,2.123-1.393.541.541,0,0,0,.012-.1ZM247,159.637a2.2,2.2,0,0,0,.425-2.993,2.1,2.1,0,0,0-2.932-.484,2.177,2.177,0,0,0-.425,2.993,2.107,2.107,0,0,0,2.932.484Zm-41.17,30.055a2.107,2.107,0,1,0-2.932-.484,2.116,2.116,0,0,0,2.932.484ZM65.052,46.055a2.22,2.22,0,0,0-1.8-2.47,2.133,2.133,0,0,0-.619,4.22,2.163,2.163,0,0,0,2.42-1.749ZM57.14,96.526A2.164,2.164,0,0,0,55.4,94.1a2.115,2.115,0,0,0-.678,4.176,2.149,2.149,0,0,0,2.418-1.748Zm100.716,10.515a2.259,2.259,0,0,0-.714-2.939,2.123,2.123,0,0,0-2.871.766,2.081,2.081,0,0,0,.626,2.872l.039.021a2.116,2.116,0,0,0,2.92-.72Zm-26.577,43.634a2.147,2.147,0,0,0-.708-2.935l-.006,0a2.047,2.047,0,0,0-2.819.7h0a2.1,2.1,0,0,0,.679,2.885,2.071,2.071,0,0,0,2.855-.648Zm59.951-33.348a2.1,2.1,0,0,0-.658-2.89,2.081,2.081,0,0,0-2.879.659,2.1,2.1,0,0,0,.59,2.845,2.126,2.126,0,0,0,2.947-.615Zm-28.219,42.295a2.127,2.127,0,0,0-3.515-2.394,2.25,2.25,0,0,0,.569,3.008,2.176,2.176,0,0,0,2.946-.614Zm-76.56-58.476a2.157,2.157,0,0,0-1.7-2.489,2.12,2.12,0,0,0-.929,4.131.29.29,0,0,0,.091.016,2.1,2.1,0,0,0,2.518-1.592.177.177,0,0,0,.02-.066Z",
    transform: "translate(175.846 0)",
    fill: "#428dfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19396",
    "data-name": "Trazado 19396",
    d: "M0,9.846,15.318,0l9.8,15.381L9.8,25.226Z",
    transform: "translate(383.61 8.668)",
    fill: "#235677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19397",
    "data-name": "Trazado 19397",
    d: "M5.546,0,22.869,5.569l-5.546,17.4L0,17.4Z",
    transform: "translate(42.708 45.212)",
    fill: "#a1c3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19398",
    "data-name": "Trazado 19398",
    d: "M0,13.167,20.486,0,33.6,20.571,13.113,33.737Z",
    transform: "translate(137.307 76.551)",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9300",
    "data-name": "Grupo 9300",
    transform: "translate(0 111.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19399",
    "data-name": "Trazado 19399",
    d: "M93.922,53.406a.743.743,0,0,1-.617-.33C72.88,22.451,37.4,2.683.716,1.487A.741.741,0,0,1,0,.719.775.775,0,0,1,.766,0C37.922,1.21,73.852,21.232,94.539,52.248a.742.742,0,0,1-.617,1.158Z",
    transform: "translate(0 0)",
    fill: "#428dfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9301",
    "data-name": "Grupo 9301",
    transform: "translate(10.708 221.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19400",
    "data-name": "Trazado 19400",
    d: "M81.22,15.334A.733.733,0,0,1,80.8,15.2C57.928-.846,25.891-3.023,1.08,9.78a.737.737,0,0,1-1-.322.747.747,0,0,1,.32-1C25.689-4.6,58.338-2.373,81.644,13.977a.744.744,0,0,1,.183,1.036A.73.73,0,0,1,81.22,15.334Z",
    transform: "translate(0 0)",
    fill: "#428dfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9302",
    "data-name": "Grupo 9302",
    transform: "translate(267.991 104.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19401",
    "data-name": "Trazado 19401",
    d: "M.742,41.719a.738.738,0,0,1-.486-.182.748.748,0,0,1-.074-1.051A117.783,117.783,0,0,1,91.625.042c.408.01.73.055.72.467s-.34.425-.741.425h-.021c-34.14,0-67.9,14.311-90.283,40.228C1.153,41.334.948,41.719.742,41.719Z",
    transform: "translate(0 0)",
    fill: "#428dfc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9308",
    "data-name": "Grupo 9308",
    transform: "translate(603.666 100.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9307",
    "data-name": "Grupo 9307",
    transform: "matrix(0.849, -0.528, 0.528, 0.849, 0, 82.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9306",
    "data-name": "Grupo 9306",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-i3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bottom-i3",
    width: 155.914,
    height: 121.455,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top-i3",
    d: "M0,0,77.957,60.735,155.914,0Z",
    fill: "#eee"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9313",
    "data-name": "Grupo 9313",
    transform: "translate(189 479.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9312",
    "data-name": "Grupo 9312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9311",
    "data-name": "Grupo 9311",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2732",
    "data-name": "Rect\\xE1ngulo 2732",
    width: 394.382,
    height: 255.338,
    transform: "translate(34.986)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2733",
    "data-name": "Rect\\xE1ngulo 2733",
    width: 375.299,
    height: 196.66,
    transform: "translate(44.528 19.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9309",
    "data-name": "Grupo 9309",
    transform: "translate(221.82 92.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19402",
    "data-name": "Trazado 19402",
    d: "M567.261,249.2H392.667V186.261A22.522,22.522,0,0,1,415.194,163.8H567.259S567.261,249.2,567.261,249.2ZM395.052,246.82H564.874V166.176H415.194a20.138,20.138,0,0,0-20.142,20.085Z",
    transform: "translate(-392.667 -163.796)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9310",
    "data-name": "Grupo 9310",
    transform: "translate(167.819 118.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19403",
    "data-name": "Trazado 19403",
    d: "M471.666,294.794H297.074V231.859A22.521,22.521,0,0,1,319.6,209.394H471.668l0,85.4Zm-172.207-2.378H469.281V211.774H319.6a20.136,20.136,0,0,0-20.139,20.085Z",
    transform: "translate(-297.074 -209.394)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19404",
    "data-name": "Trazado 19404",
    d: "M451.566,105.525H117.543V84.484a17.554,17.554,0,0,1,17.577-17.53H451.564v38.572Z",
    transform: "translate(-51.142 -29.131)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2734",
    "data-name": "Rect\\xE1ngulo 2734",
    width: 464.354,
    height: 17.445,
    transform: "translate(0 237.893)",
    fill: "#235677"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2735",
    "data-name": "Rect\\xE1ngulo 2735",
    width: 20.675,
    height: 20.619,
    transform: "translate(120.861 44.409)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2736",
    "data-name": "Rect\\xE1ngulo 2736",
    width: 20.675,
    height: 20.619,
    transform: "translate(248.538 117.38)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2737",
    "data-name": "Rect\\xE1ngulo 2737",
    width: 5.656,
    height: 5.641,
    transform: "translate(121.28 47.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2738",
    "data-name": "Rect\\xE1ngulo 2738",
    width: 5.656,
    height: 5.641,
    transform: "translate(399.109 198.979)",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2739",
    "data-name": "Rect\\xE1ngulo 2739",
    width: 5.656,
    height: 5.641,
    transform: "translate(237.653 224.324)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2740",
    "data-name": "Rect\\xE1ngulo 2740",
    width: 15.932,
    height: 15.888,
    transform: "translate(133.505 73.573)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2741",
    "data-name": "Rect\\xE1ngulo 2741",
    width: 15.932,
    height: 15.888,
    transform: "translate(318.092 53.542)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2742",
    "data-name": "Rect\\xE1ngulo 2742",
    width: 15.932,
    height: 15.888,
    transform: "translate(288.848 89.803)",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2743",
    "data-name": "Rect\\xE1ngulo 2743",
    width: 11.188,
    height: 11.157,
    transform: "translate(109.425 87.439)",
    fill: "#e94a47"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2744",
    "data-name": "Rect\\xE1ngulo 2744",
    width: 11.188,
    height: 11.157,
    transform: "translate(209.017 108.721)",
    fill: "#1d72d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2745",
    "data-name": "Rect\\xE1ngulo 2745",
    width: 9.609,
    height: 9.584,
    transform: "translate(136.667 110.297)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2746",
    "data-name": "Rect\\xE1ngulo 2746",
    width: 9.609,
    height: 9.584,
    transform: "translate(136.667 173.361)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2747",
    "data-name": "Rect\\xE1ngulo 2747",
    width: 44.528,
    height: 11.102,
    transform: "translate(44.528 241.065)",
    fill: "#123a53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2748",
    "data-name": "Rect\\xE1ngulo 2748",
    width: 30.757,
    height: 11.102,
    transform: "translate(104.856 241.065)",
    fill: "#123a53"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9316",
    "data-name": "Grupo 9316",
    transform: "translate(600.544 338.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9315",
    "data-name": "Grupo 9315",
    transform: "matrix(0.89, -0.455, 0.455, 0.89, 0, 59.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9314",
    "data-name": "Grupo 9314",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-i5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bottom-i5",
    width: 131.058,
    height: 102.249,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top-i5",
    d: "M0,0,65.529,51.131,131.058,0Z",
    fill: "#eee"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9319",
    "data-name": "Grupo 9319",
    transform: "translate(426.469 232.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9318",
    "data-name": "Grupo 9318",
    transform: "matrix(0.534, -0.846, 0.846, 0.534, 0, 67.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9317",
    "data-name": "Grupo 9317",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-i6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bottom-i6",
    width: 79.652,
    height: 62.139,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top-i6",
    d: "M0,0,39.826,31.073,79.652,0Z",
    fill: "#eee"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9322",
    "data-name": "Grupo 9322",
    transform: "translate(376.931 390.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9321",
    "data-name": "Grupo 9321",
    transform: "matrix(0.813, -0.583, 0.583, 0.813, 0, 62.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9320",
    "data-name": "Grupo 9320",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-i7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bottom-i7",
    width: 107.332,
    height: 83.606,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top-i7",
    d: "M0,0,53.666,41.808,107.332,0Z",
    fill: "#eee"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGracias);
export default __webpack_public_path__ + "static/media/gracias.9a561aee1546793976f362b690c23c2c.svg";
export { ForwardRef as ReactComponent };